import React from 'react';
import './CardContainer.css';

const CardContainer = ({ children, className = '', onClick, ...props }) => {
  const isClickable = !!onClick;
  
  return (
    <div 
      className={`card-container ${isClickable ? 'clickable' : ''} ${className}`}
      onClick={onClick}
      style={{ cursor: isClickable ? 'pointer' : 'default', ...props.style }}
      {...props}
    >
      {children}
    </div>
  );
};

export default CardContainer;